// extracted by mini-css-extract-plugin
module.exports = {"button":"StyledButton_button__39Q7-","icon":"StyledButton_icon__3wZmk","text":"StyledButton_text__F0REJ"};